import { FabricPlugin } from "../../../FabricPlugin";
import { fillElement, strokeElement } from "../../../../utils/utils";

/**
 * @description Fabric hexagon class. Certain plugins extend this
 */
export class FabricHexagon extends FabricPlugin {
    constructor(options, ctx, data) {
        super(options, ctx, data);
        this.points = { start: 20, end: 20, initial: 4 };
    }

    /**
     * @description Draws a hexagon
     * @param {Number} centerX  - hexagon center x
     * @param {Number} centerY - hexagon center y
     * @param {Number} radius - the radius of the hexagopn
     * @param {Object} styles - styles to set
     * @param {Object} ctx  - canvas 2d context
     */
    drawHexagon(centerX, centerY, radius, styles, ctx) {
        const sides = 6;
        ctx.beginPath();
        ctx.moveTo(centerX + radius, centerY);
        for (let p = 1; p < sides; p++) {
            ctx.lineTo(centerX + radius * Math.cos(p * 2 * Math.PI / sides), centerY + radius * Math.sin(p * 2 * Math.PI / sides));
        }
        fillElement(ctx, styles);
        strokeElement(ctx, styles);
        ctx.closePath();
    }
}
